import { FEATURE_FLAGS, CAPTAIN_ANY_FLAG } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import CaptainPageRouteView from './pages/CaptainPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantMaterialsIndex from './assistants/materials/Index.vue';
import AssistantAiPanelIndex from './assistants/ai_panel/Index.vue';
import AssistantToolSelectionIndex from './assistants/tool_selection/Index.vue';
import AssistantFieldRulesIndex from './assistants/field_rules/Index.vue';
import AssistantRoutingRulesIndex from './assistants/routing_rules/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import AssistantSchedulesIndex from './assistants/schedules/Index.vue';
import CopilotGlobalIndex from './copilot/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

// Captain antigo ou V2: com só a flag antiga, a conta que tem apenas a V2 era
// negada pelo guard do router e caía no Hub sem aviso.
const meta = {
  permissions: ['administrator', 'agent', 'captain_view'],
  featureFlag: CAPTAIN_ANY_FLAG,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaCustomTools = {
  permissions: ['administrator', 'agent', 'captain_view'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaV2 = {
  permissions: ['administrator', 'agent', 'captain_view'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaCopilot = {
  permissions: ['administrator', 'copilot_use'],
  featureFlag: CAPTAIN_ANY_FLAG,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

// SiteUp: páginas V2 cujos endpoints de backend são admin-only. Restringir o
// acesso aqui evita o item de menu abrir uma página em branco para não-admins
// (ex.: Painel da IA, cujos ai_agent_metrics/ai_agent_feedbacks exigem admin) —
// o roteador faz o redirect padrão de "sem acesso" em vez de renderizar vazio.
const metaV2Admin = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'captain_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'captain_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'captain_tools_index',
    meta: metaCustomTools,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'captain_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'captain_assistants_playground_index',
    meta,
  },
  // SiteUp (Onda C): Agendas do Captain (horários de atendimento por funil).
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/schedules'),
    component: AssistantSchedulesIndex,
    name: 'captain_assistants_schedules_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'captain_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'captain_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'captain_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'captain_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'captain_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/materials'
    ),
    component: AssistantMaterialsIndex,
    name: 'captain_assistants_materials_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/ai-panel'
    ),
    component: AssistantAiPanelIndex,
    name: 'captain_assistants_ai_panel_index',
    meta: metaV2Admin,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/tools-selection'
    ),
    component: AssistantToolSelectionIndex,
    name: 'captain_assistants_tool_selection_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/field-rules'
    ),
    component: AssistantFieldRulesIndex,
    name: 'captain_assistants_field_rules_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/:assistantId/settings/routing-rules'
    ),
    component: AssistantRoutingRulesIndex,
    name: 'captain_assistants_routing_rules_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/captain/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'captain_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent', 'captain_view'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/captain/copiloto'),
    component: CopilotGlobalIndex,
    name: 'captain_copilot_global_index',
    meta: metaCopilot,
  },
  {
    path: frontendURL('accounts/:accountId/captain/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'captain_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/captain'),
    component: CaptainPageRouteView,
    redirect: to => {
      return {
        name: 'captain_assistants_index',
        params: {
          navigationPath: 'captain_assistants_responses_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
